<template>
  <div class="mails-compose-button">
    <emails-login v-if="!emails_is_signed_in"></emails-login>
    <o-button v-else @click="handleCompose" type="is-info" icon-left="plus">Compose</o-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import ComposeModal from './ComposeModal'
import EmailsLogin from './../../../pages/emails/EmailsLogin'

export default {
  components: { ComposeModal, EmailsLogin },
  computed: {
    ...mapGetters([
        'emails_get_profile',
        'emails_is_signed_in',
    ]),
  },
  data() {
    return {
    }
  },
  methods: {
      ...mapActions([
          'emails_set_gapi',
      ]),
      handleCompose() {
            const message = {
            attaches: [],
            bcc: [],
            body: '',
            cc: [],
            source_body: '',
            subject: '',
            from: this.emails_get_profile.emailAddress,
            to: [],
        }
        const props = {
            message,
        }
        this.openModalComponent(ComposeModal, props)
      },
  },
  mounted() {
  },
}
</script>

<style lang="sass" scoped>

</style>